// Shared current-page state. Set by pages/[...slug].vue on every content
// navigation; consumed by layouts/default.vue (right-sidebar TOC) and
// components/PageWatcher.vue (heading observer). This replaces @nuxt/content
// v2's documentDriven `useContent()` globals, which were removed in v3.
export const useCurrentDoc = () => useState<any | null>('current-doc', () => null);
export const useCurrentSurround = () => useState<any[]>('current-surround', () => []);
